// /src/auth/RequireAuth.jsx
import React from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useAuth } from './AuthContext';

export default function RequireAuth({ allowed = [] }) {
  const { ready, user } = useAuth();
  const location = useLocation();

  if (!ready) {
    // 로딩 상태 표시 (흰 화면 방지)
    return (
      <div style={{ padding: 24, fontSize: 16 }}>
        세션 확인 중…
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" replace state={{ from: location }} />;
  }

  if (allowed.length > 0 && !allowed.includes(String(user.role || '').toUpperCase())) {
    return <Navigate to="/unauthorized" replace />;
  }

  return <Outlet />;
}
